export default "__VITE_ASSET__C$vlkNV6__"